// extracted by mini-css-extract-plugin
export var formContainer = "_jr-0";
export var message = "_jr-1";